import {vpost} from "@/util/post";

export const access = {
    listAll: async () => {
        return (await vpost("/access/listAll")).data;
    },
}
